/**
 * PATH: apps/quote/src/components/builder/panels/ai-assistant/SuggestionCard.tsx
 * PURPOSE: Suggestion card for search-based AI suggestions
 */

import { Plus } from 'lucide-react'
import { formatCurrency } from '@/lib/utils'
import type { AISuggestion } from '@/lib/quoteApi'

export default function SuggestionCard({
  suggestion,
  onApply,
}: {
  suggestion: AISuggestion
  onApply: () => void
}) {
  return (
    <div className="p-2 bg-slate-50 dark:bg-slate-700/50 rounded-md">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-slate-900 dark:text-white truncate">
            {suggestion.item_name}
          </p>
          <p className="text-xs text-slate-500">
            {suggestion.source} • {suggestion.unit}
          </p>
        </div>
        <div className="text-right shrink-0">
          <p className="text-sm font-semibold text-blue-600">
            {formatCurrency(suggestion.unit_price || 0)}
          </p>
          <p className="text-[10px] text-slate-400">{Math.round(suggestion.confidence)}% match</p>
        </div>
      </div>
      <button
        onClick={onApply}
        className="mt-1.5 w-full flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        <Plus className="w-3 h-3" />
        Add to Quote
      </button>
    </div>
  )
}
